(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('mailInputForm', mailInputForm);

    function mailInputForm() {
        //binding document: https://stackoverflow.com/a/37818829
        var directive = {
            templateUrl: '/app/common/mail-input.html',
            scope: {
                input: '=', // model connection
                isRegistered: '=', // returns registration status
                isRequired: '<', // check if required
                isValid: '=', // returns validation status
                mailChanged: '=', // returns phone change status
                hasOtp: '<', //check if require OTP
                waitingOtp: '=', //check if OTP is waiting
                otpType: '@',
                isRequired: '<',
                name: '@',
                checkRegistered: '<', //check if registered
                isDisabled: '=',
                handleOnChange: '&',
                handleOnBlur: '&',
                handleOtpVerify: '&',
                disableWarning: '<',
                showBubbleMessage: '<', //shows additional notifier messages
                hideRegisteredWarning: '<' //hides registered warning
            },
            restrict: 'EA',
            controller: mailInputFormController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elm, attrs) {
                // console.log("link: ", scope)
                // console.log("elm: ", elm)
                // console.log("attrs: ", attrs)
            }
        };
        return directive;

    }

    mailInputFormController.$inject = ['userSvc', 'user_factory', '$translate', 'notifierSvc', 'otpService', '$timeout', '$rootScope'];
    function mailInputFormController(userSvc, user_factory, $translate, notifierSvc, otpService, $timeout, $rootScope) {
        var vm = this;

        $timeout(function () {
            window.oldMailAddress = vm.input;
            vm.checkEmail();
        }, 100);


        vm.showRequireOtp = function () {
            return !vm.isDisabled && vm.hasOtp && vm.mailChanged && vm.input && vm.input.length && vm.isValid && !vm.isRegistered && !vm.disableWarning && !vm.isFirstMail;
        };

        vm.showError = function () {
            return !vm.isDisabled && vm.mailChanged && (!vm.isValid || (vm.isRegistered && !vm.hideRegisteredWarning) || (!vm.input && vm.isRequired)) && !vm.disableWarning && !vm.isFirstMail;
        };


        vm.checkEmail = function () {
            if (vm.isDisabled) return;

            vm.isValid = true;
            if (typeof vm.isRegistered !== "undefined")
                vm.isRegistered = false;


            vm.isFirstMail = ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isEmailFilled && !$rootScope.recommendedFieldsToFill.isEmailConfirmed) ? false : (vm.input && window.oldMailAddress && vm.input === window.oldMailAddress);
            vm.mailChanged = !vm.isFirstMail;

            if ((!vm.input || vm.input.length === 0) && vm.isRequired) {
                vm.isValid = false;
                vm.mailChanged = false;
                return;
            }

            var validated = validateEmail(vm.input);
            vm.isValid = vm.input && vm.input.length ? validated : true;
            if (validated) {
                if (typeof vm.isDisabled !== "undefined")
                    vm.isDisabled = true;

                // Additional check to prevent API call for bank users
                if ($rootScope.isBank) {
                    if (typeof vm.isDisabled !== "undefined")
                        vm.isDisabled = false;
                    vm.isValid = true;
                    return;
                }

                userSvc.checkEmail(vm.input).then(function (result) {
                    if (typeof result.status !== "undefined" && result.status === 305) {
                        vm.isValid = false;
                    }
                    else {
                        vm.isValid = true;
                    }
                    if (vm.checkRegistered) {
                        if (vm.input) {
                            var checkEmail = user_factory.any({ email: vm.input });
                            checkEmail.$promise.then(function (response) {
                                if (response.result) {
                                    if (vm.showBubbleMessage && !vm.hideRegisteredWarning)
                                        $translate('valid_email21').then(function (translation2) {
                                            notifierSvc.show({ message: translation2, type: "error" });
                                        });
                                    if (typeof vm.isRegistered !== "undefined")
                                        vm.isRegistered = ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isEmailFilled && !$rootScope.recommendedFieldsToFill.isEmailConfirmed) ? false : true;
                                }
                            }).finally(() => {
                                if (typeof vm.isDisabled !== "undefined")
                                    vm.isDisabled = false;
                            });
                        }
                        else {
                            if (typeof vm.isDisabled !== "undefined")
                                vm.isDisabled = false;
                        }
                    }
                    else {
                        if (typeof vm.isDisabled !== "undefined")
                            vm.isDisabled = false;
                    }
                }).finally(() => {
                    if (typeof vm.isDisabled !== "undefined")
                        vm.isDisabled = false;
                });
            }
            vm.waitingOtp = vm.showRequireOtp();
            // if (window.oldMailAddress && window.oldMailAddress.length && (!vm.input || !vm.input.length)) {
            //     window.oldMailAddress = undefined;
            // }
            handleChange();
        };


        function validateEmail(email) {
            return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                email
            );
        }
        vm.onInit = function () {
            //console.log("onInit: ", vm)
        };
        vm.$onDestroy = function () {
        };

        let handleChange = function () {
            if (vm.handleOnChange)
                vm.handleOnChange({ input: vm.input });
        };
        vm.handleBlur = function () {
            vm.handleOnBlur({ input: vm.input });
        };
        vm.callOtp = function () {
            vm.mailChanged = true;
            vm.loading = true;
            otpService.callOtp(vm.otpType || "profileUpdate", 0, vm.input).then(function (resp) {
                vm.loading = false;
                otpService.closeDialog();
                if (!resp) {
                    return;
                }
                vm.mailChanged = false;
                window.oldMailAddress = vm.input;
                vm.waitingOtp = vm.showRequireOtp();
                vm.handleOtpVerify({ response: resp });
            }, function (err) {
                otpService.closeDialog();
                retryOTP(err.validateRequest);
            }).finally(() => {
            });
        };

        function retryOTP(validateRequest) {
            vm.mailChanged = true;
            otpService.callOtp('retry', validateRequest.verificationType, validateRequest.verificationAddress, validateRequest.codeExpireDate, validateRequest.verificationToken).then(
                function (resp) {
                    vm.loading = false;
                    otpService.closeDialog();
                    if (!resp) {
                        return;
                    }
                    vm.mailChanged = false;
                    window.oldMailAddress = vm.input;
                    vm.waitingOtp = vm.showRequireOtp();
                    vm.handleOtpVerify({ response: resp });
                },
                function (err) {
                    otpService.closeDialog();
                    retryOTP(err.validateRequest);
                }
            );
        }
    }
})();
